module.exports = ".action-dialog {\n        border-radius: 6px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/upload-cleared-offer-dialog/upload-cleared-offer-dialog.component.css
// module id = ./src/app/shared/components/upload-cleared-offer-dialog/upload-cleared-offer-dialog.component.css
// module chunks = main